<script setup lang="ts">
import { useRoute, RouterView } from "vue-router";

const route = useRoute();
</script>

<template>
  <RouterView />
</template>
